import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import authUser from "./auth/reducer";
import facilityAll from "./facilities/reducer";
import applianceAll from "./Appliance/reducers";
import objectCount from "./objectCount/reducers";
import employeeAll from "./employee/reducer";
import logs from "./logs/reducer";
const reducers = combineReducers({
  menu,
  settings,
  authUser,
  facilityAll,
  applianceAll,
  objectCount,
  employeeAll,
  logs,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_USER") {
    state = undefined;
  }

  return reducers(state, action);
};

export default rootReducer;
